import { createAction, props } from '@ngrx/store';

export const UI_LOADING = createAction('[UI] :: Loading.', props<{ loading: boolean }>());
export const UI_OPEN_SIDENAV_MENU = createAction('[UI] :: Open Sidenav menu.', props<{ open: boolean }>());
export const UI_OPEN_SIDENAV_USER = createAction('[UI] :: Open Sidenav usuario.', props<{ open: boolean }>());

export const UI_RESET = createAction('[UI] :: Reset.');

